<div class="duplicate-patients p-3" [class.has-tabs]="hasTabs()">
  <div class="mat-container">
    <div class="d-flex flex-row align-items-center justify-content-between">
      <span>The following {{ duplicates().length }} patient(s) match your current input. Please verify you are not adding a duplicate patient</span>
      <button mat-icon-button type="button" (click)="toggle()">
        <mat-icon class="md-20">{{ isOpen() ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
      </button>
    </div>
    <mat-list class="duplicates" [class.visible]="isOpen()">
      @for (duplicate of duplicates(); track duplicate.profileId) {
        <mat-list-item>
          <div class="ms-2 me-auto d-flex flex-row align-items-center justify-content-between w-100">
            <div class="fw-bold">{{ duplicate.profileId }} {{ duplicate.displayName }} {{ duplicate.identityNumber }}</div>
            <button mat-button (click)="edit(duplicate)">Edit</button>
          </div>
        </mat-list-item>
      }
    </mat-list>
  </div>
</div>
